import React, { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Loader2, CheckCircle2, XCircle } from "lucide-react";

export default function PaymentReturn({ cancel }) {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const { refreshEntitlements } = useAuth();
  const [state, setState] = useState(cancel ? "cancel" : "checking");

  useEffect(() => {
    if (cancel) { const t = setTimeout(() => navigate("/"), 2500); return () => clearTimeout(t); }
    const sid = params.get("session_id");
    if (!sid) { navigate("/"); return; }
    let tries = 0;
    let stop = false;
    const poll = async () => {
      if (stop) return;
      tries += 1;
      try {
        const r = await api.get(`/payments/status/${sid}`);
        if (r.data.payment_status === "paid") {
          await refreshEntitlements();
          setState("success");
          setTimeout(() => navigate("/"), 1800);
          return;
        }
      } catch (e) { /* keep polling */ }
      if (tries < 15) setTimeout(poll, 2000);
      else setState("timeout");
    };
    poll();
    return () => { stop = true; };
  }, [cancel]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#050505] text-white" data-testid="payment-return">
      <div className="text-center max-w-sm px-6">
        {state === "checking" && (<><Loader2 className="h-10 w-10 text-[#007AFF] animate-spin mx-auto" /><p className="mt-4 text-lg font-semibold">Confirming your payment…</p><p className="text-sm text-[#A3A3A3] mt-1">This only takes a moment.</p></>)}
        {state === "success" && (<><CheckCircle2 className="h-12 w-12 text-[#10B981] mx-auto" /><p className="mt-4 text-lg font-semibold" data-testid="payment-success">Payment successful!</p><p className="text-sm text-[#A3A3A3] mt-1">Your new features are unlocked. Redirecting…</p></>)}
        {state === "cancel" && (<><XCircle className="h-12 w-12 text-[#F59E0B] mx-auto" /><p className="mt-4 text-lg font-semibold">Checkout cancelled</p><p className="text-sm text-[#A3A3A3] mt-1">No charge was made. Taking you back…</p></>)}
        {state === "timeout" && (<><Loader2 className="h-10 w-10 text-[#A3A3A3] mx-auto" /><p className="mt-4 text-lg font-semibold">Still processing</p><p className="text-sm text-[#A3A3A3] mt-1">Your payment is being finalised.</p><Button onClick={() => navigate("/")} className="mt-4 bg-[#007AFF] hover:bg-[#005BB5] rounded-full">Go to dashboard</Button></>)}
      </div>
    </div>
  );
}
